<ng-container>
    <div class="sticky-header">
        <app-header></app-header>
    </div>

    <div class="container-fluid container-padding-12">
        <div class="dashboardBlock">
            <div class="row dashboardBackGrnd" [ngClass]="isArabic ? 'menuArabicAlign' : ''">
                <div class="col-md-3 col-lg-3">
                    <app-menu [selectedCategory]="selectedCategory" [categoryList]="categoryList"
                        [categoryArabicList]="categoryArabicList" [assessmentDetails]="assessmentDetails"
                        [progressCountState]="progressCountState" (changeCategory)="categoryFromMenu($event)"
                        (changeTab)="tabChangeFromMenu($event)"></app-menu>
                </div>
                <div class="col-md-9 col-lg-9">
                    <div class="fullRightSection px-md-4">
                        <div class="qstn-tabs">
                            <app-questionnaire-tabs [assessmentDetails]="assessmentDetails"
                                [totalEachTypeQuestions]="totalEachTypeQuestions"
                                [showGeneralSection]="showGeneralSection" [showInherentSection]="showInherentSection"
                                [showControlSection]="showControlSection"></app-questionnaire-tabs>
                        </div>
                        <div *ngIf="noOfTypeQues && noOfTypeQues[0]?.totalcount <= 0" class="mt-5 errNoQues"
                            [ngClass]="isArabic ? 'arabicAlign' : ''">
                            <span *ngIf="!isArabic">No question available for this assessment type.</span>
                            <span *ngIf="isArabic">لا يوجد سؤال متاح لهذا النوع من التقييم.</span>
                        </div>

                        <app-category [selectedCategoryDetails]="selectedCategoryDetails"
                            [isLastSection]="isSelectedSectionLast" [isLastCategory]="isSelectedCategoryLast"
                            [unansweredQues]="unansweredQues" [returnQues]="returnQuestion"
                            [progressCountState]="progressCountState"
                            *ngIf="noOfTypeQues && noOfTypeQues[0]?.totalcount > 0"
                            (resetReturnQues)="handleResetReturnQues()"></app-category>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="footerDiv">
        <app-footer></app-footer>
    </div>
</ng-container>